<template>
  <div class="sensor-data p-4 relative min-h-20">

    <div v-if="!sensor.sensors || sensor.loading" class="loader flex items-center justify-center absolute inset-0">
      <Spinner :loading="!sensor.sensors || sensor.loading" :color="true"/>
    </div>

    <div class="rounded-lg bg-gray-200">
      <h2
        v-if="!!sensor.name"
        class="font-semibold font-lg py-4 px-2 text-center text-primary"
      >{{sensor.name}}</h2>

      <div v-if="sensor.airQualityLevel" class="text-center bg-white shadow rounded-lg p-4">
        <span class="text-gray-600 font-semibold text-lg">{{$t('air.quality')}}</span>

        <h3 :class="qualityClass" class="my-4">
          <Icon :icon="['far', qualityIcon, 'text-6xl']"/>
          <span class="block font-semibold text-2xl uppercase">
            {{$t(`air.level.${sensor.airQualityLevel}`)}}
          </span>
        </h3>

        <ul class="flex border border-l-0">
          <li v-for="s in sensor.sensors" :key="s.type" class="flex-1 border-l py-2">
            <span class="block uppercase text-gray-600 font-extrabold text-sm mb-2">{{s.type}}</span>
            <span class="text-2xl">
              {{s.value}}
              <span class="absolute ml-1 pt-2 text-xs">
                <Icon :icon="['fas', changeIcon(s.type)]"/>
              </span>
            </span>
            <span class="block text-xs">µg/m<sup>3</sup></span>
          </li>
        </ul>
      </div>

      <CompanyDataBox
        v-if="!!sensor.sponsor"
        :label="$t('sponsor')"
        :company="sensor.sponsor"
      ></CompanyDataBox>

      <div
        v-if="!!sensor.sponsor &&!!sensor.vendor"
        class="divider m-2 mt-4 h-px bg-gray-400"
      ></div>

      <CompanyDataBox
        v-if="!!sensor.vendor"
        :label="$t('manufacturer')"
        :company="sensor.vendor"
      ></CompanyDataBox>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Icon from '@/components/atoms/Icon';
import Spinner from '@/components/atoms/Spinner';
import CompanyDataBox from '@/components/atoms/CompanyDataBox';

export default {
  name: 'SensorData',
  components: {
    Icon,
    Spinner,
    CompanyDataBox,
  },

  computed: {
    ...mapGetters([
      'sensor',
      'lastChange',
      'isLoading',
    ]),

    qualityIcon() {
      const faces = [
        'fa-laugh',
        'fa-grin',
        'fa-smile',
        'fa-meh',
        'fa-frown',
        'fa-angry',
      ];
      return faces[this.sensor.airQualityLevel - 1];
    },

    qualityClass() {
      return `color-quality-${this.sensor.airQualityLevel}`;
    },
  },

  data() {
    return {
      refreshInterval: null,
    };
  },

  mounted() {
    this.updateSensor();
  },

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },

  methods: {
    ...mapActions([
      'getSensor',
    ]),

    changeIcon(sensorType) {
      const { lastChange } = this;

      if (!!lastChange && !!lastChange[sensorType] && lastChange[sensorType].length > 1) {
        const measurements = this.lastChange[sensorType];

        if (measurements[0] < measurements[1]) {
          return 'fa-arrow-down text-green-300';
        }

        if (measurements[0] > measurements[1]) {
          return 'fa-arrow-up text-red-300';
        }
      }

      return '';
    },

    updateSensor() {
      this.refreshInterval = setInterval(
        () => this.getSensor(this.sensor.id),
        1000 * 60 * 30, // refresh sensor data every hour
      );
    },
  },
  
};
</script>

<style lang="scss" scoped>
.loader {
  background-color: rgba(#ffffff, .5);
}
</style>
